import type BaseModal from '~/components/Base/BaseModal/BaseModal.vue'

export function useModelValue(
  props: InstanceType<typeof BaseModal>['$props'],
  emit: InstanceType<typeof BaseModal>['$emit'],
  options: {
    open: () => boolean
    close: () => boolean
  }
) {
  let skip = false
  const { open, close } = options

  const timeOpened = shallowRef()
  /** The truth of modal open or close */
  const _modelValueLocal = shallowRef(false)

  const modelValue = computed(
    () => props.modelValue
  )

  /**
   * The proxy of `_modelValueLocal`
   */
  const modelValueLocal = computed({
    get: () => _modelValueLocal.value,
    set: (val) => {
      setModelValueLocal(val)
    }
  })

  /**
   * Because of the open/close can be stopped in `@beforeOpen`, `@beforeClose` events.
   * So the function is to make sure `_modelValueLocal`, `modelValue` are always the same value
   */
  function setModelValueLocal(val: boolean) {
    const success = val ? open() : close()

    if (success) {
      _modelValueLocal.value = val
      if (val !== modelValue.value) {
        emit('update:modelValue', val)
      }
    } else {
      skip = true
      emit('update:modelValue', !val)
      nextTick(() => {
        skip = false
      })
    }
  }

  watch(modelValue, (val) => {
    if (skip) {
      return
    }
    modelValueLocal.value = !!val

    if (modelValueLocal.value) {
      timeOpened.value = Date.now()
    }
  })

  const checkDisabledClose = () => {
    if (!timeOpened.value) {
      return
    }
    const result = Date.now() - timeOpened.value < 300

    timeOpened.value = undefined
    return result
  }
  return {
    modelValueLocal,
    checkDisabledClose
  }
}
